module.exports = __webpack_public_path__ + "img/C_logopackhai.67aa940e.png";